// @flow

import React from 'react';
import type { Node } from 'react';

import { raCmsContentCls } from '@riseart/antd-provider/dist/website/variables.less';

type Props = {
  children: Node,
};

/**
 * CmsContainer
 *
 * @param {Props} props
 * @returns {Node}
 */
export const CmsContainer = ({ children }: Props): Node => (
  <div className={raCmsContentCls}>{children}</div>
);
